module.exports = __webpack_public_path__ + "img/member01.c1602e21.jpg";